import Layout from "@/components/Layout";
import MonitoringEmailPreferenceForm from "@/components/settings/MonitoringEmailPreferenceForm";
import type { MonitoringEmailPreference } from "@/types";

type ShowProps = {
  monitoring_email_preference: MonitoringEmailPreference;
};

export default function Show({ monitoring_email_preference }: ShowProps) {
  return (
    <Layout title="Settings">
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">Settings</h1>
        <p className="text-gray-500">Manage monitoring email preferences for your account.</p>
      </div>

      <MonitoringEmailPreferenceForm preference={monitoring_email_preference} />
    </Layout>
  );
}
